export const headerCrop = [
  "ID Coltura",
  "Coltura",
  "N",
  "P2O5",
  "K2O",
  "CaO",
  "MgO",
  "SO3",
];

export const supplyKeys = headerCrop.map((value) => `count${value}`).slice(2);

headerCrop.map((value) => `count${value}`).slice(2);

export const cropRowsDefault = [
  {
    cropId: "00001",
    crop: "FRAGOLA",
    countN: 1,
    countP2O5: 2,
    countK2O: 3,
    countMgO: 5,
    countSO3: 6,
    countCaO: 4,
  },
  {
    cropId: "00002",
    crop: "KIWI",
    countN: 0,
    countP2O5: 30,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
  {
    cropId: "00003",
    crop: "VITE da vino",
    countN: 50,
    countP2O5: 50,
    countK2O: 50,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
  {
    cropId: "00004",
    crop: "PESCO",
    countN: 0,
    countP2O5: 30,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
  {
    cropId: "00005",
    crop: "POMODORO",
    countN: 0,
    countP2O5: 30,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
  {
    cropId: "00006",
    crop: "ZAFFERANO",
    countN: 0,
    countP2O5: 30,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
  {
    cropId: "00007",
    crop: "Pera",
    countN: 0,
    countP2O5: 30,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
  {
    cropId: "00008",
    crop: "Mela",
    countN: 0,
    countP2O5: 30,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
  {
    cropId: "00009",
    crop: "Carciofo",
    countN: 0,
    countP2O5: 30,
    countK2O: 0,
    countCaO: 0,
    countMgO: 0,
    countSO3: 0,
  },
];
